import React from "react";
import { Link } from "react-router-dom";
import { galleryItems } from "../../mock";

export default function Gallery() {
  return (
    <section id="work" className="bg-brand-stone py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal flex flex-col gap-3">
          <span className="kicker text-brand-teal">02 / Recent work</span>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight max-w-xl">
              Straight off the tools.
            </h2>
            <p className="max-w-md text-brand-ink/60 leading-relaxed">
              A few recent jobs from around Perth, from precision channel cuts in
              polished concrete to full driveway break-outs and removals.
            </p>
          </div>
        </div>

        {/* Uniform grid: every photo the same size, multiple visible on mobile */}
        <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-5">
          {galleryItems.map((item, i) => (
            <div key={item.title} className="reveal" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="img-zoom group relative overflow-hidden rounded-xl sm:rounded-2xl bg-black aspect-square sm:aspect-[4/3]">
                <img
                  src={item.img}
                  alt={`${item.title} \u2014 concrete cutting in Perth`}
                  className="h-full w-full object-cover opacity-95"
                />
                {/* Desktop overlay caption */}
                <div className="pointer-events-none absolute inset-0 hidden sm:block bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 hidden sm:block p-6 translate-y-1 transition-transform duration-500 group-hover:translate-y-0">
                  <span className="kicker text-white/70">{item.cat}</span>
                  <h3 className="mt-1 font-display text-xl font-semibold text-white">{item.title}</h3>
                </div>
              </div>
              {/* Mobile: tiny caption below the photo */}
              <p className="sm:hidden mt-1.5 text-[11px] font-medium uppercase tracking-wide text-brand-ink/55">
                {item.cat}
              </p>
            </div>
          ))}
        </div>

        <div className="reveal mt-12 text-center">
          <Link
            to="/quote"
            className="inline-flex items-center gap-2 rounded-full border border-brand-ink/15 px-7 py-4 text-sm font-semibold text-brand-ink transition-all duration-300 hover:border-brand-teal hover:text-brand-teal"
          >
            Start your project
          </Link>
        </div>
      </div>
    </section>
  );
}
